import { IUser } from "models/User";

interface NavigationEventProps {
  location: string;
  title: string;
}

const googleTagManager = {
  navigation: (navigationData: NavigationEventProps, user : IUser) => {
    const { location, title } = navigationData;
    const gtmDataLayer = (window as any).dataLayer;
    gtmDataLayer.push({event: "page_view", page_location: location, page_title: title, user_id: user.id, userType: user.userType});
  }
};

export const sendUserDataToAnalytics = (eventName: string, user: IUser) => {
  const gtmDataLayer = (window as any).dataLayer;
  gtmDataLayer.push({
    event: eventName,
    userType: user?.userType,
    user_id: user?.id
  });
};

export default googleTagManager;